import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo-ffbp.png";

const LINKS = [
  { label: "The Approach", id: "approach" },
  { label: "The Device", id: "device" },
  { label: "Watch", id: "video" },
  { label: "The App", id: "app" },
  { label: "Pricing", id: "pricing" },
];

export const BrandMark = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-mark">
    <div
      className="w-11 h-11 rounded-xl bg-no-repeat shrink-0 ring-1 ring-white/10"
      style={{ backgroundImage: `url(${logo})`, backgroundSize: "172%", backgroundPosition: "center 11%" }}
      aria-label="Freedom From Back Pain logo"
    />
    <div className="leading-none">
      <div className="font-display font-extrabold tracking-tight text-white text-[14px]">FREEDOM FROM</div>
      <div className="text-[10px] tracking-[0.26em] text-[#38BDF8] font-semibold mt-1">BACK PAIN</div>
    </div>
  </div>
);

export const LandingNav = ({ onCta }) => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#050B1A]/85 backdrop-blur-xl border-b border-white/[0.06]" : "bg-transparent"
      }`}
      data-testid="landing-nav"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="cursor-pointer">
          <BrandMark />
        </button>

        <nav className="lg-flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-sm text-[#9AAEC6] hover:text-white transition-colors"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <button
            onClick={() => navigate("/login")}
            className="px-4 sm:px-5 py-2 rounded-full text-sm font-medium text-white border border-white/15 hover:border-[#22D3EE]/50 hover:bg-white/[0.04] transition-all"
            data-testid="nav-login-btn"
          >
            Login
          </button>
          <button
            onClick={onCta}
            className="hidden sm:inline-flex px-5 py-2 rounded-full text-sm font-semibold text-[#03101F] bg-gradient-to-b from-[#F8B14C] to-[#F59E0B] hover:-translate-y-0.5 transition-transform shadow-[0_6px_20px_rgba(245,158,11,0.35)]"
            data-testid="nav-cta-btn"
          >
            Get Instant Access
          </button>
        </div>
      </div>
    </header>
  );
};
